import apiUrlProvider, { VERIFY_PAYMENT_THIRD_CONNECT } from 'constants/api-endpoints';
import { fetchPost } from 'utils/services/fetch';

export interface IPaymentEmailDetails {
  amount: number;
  tipAmount: number;
  logo_image: string;
  redirect_link: string;
}

export const reqVerifyEmailPayment = (token: string) => {
  const url = apiUrlProvider.get(VERIFY_PAYMENT_THIRD_CONNECT);
  return fetchPost(url, {}, { isAuth: true, token }).then((response) => response);
};
